'use strict';

module.exports = /^(.+?)(\[.*\])$/;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/object/var/DEEP_QUERY_STRING_REG.js
// module id = 833
// module chunks = 0